import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import { NormasTeachingProductDTO } from "./useNormasTeachingProductById.ts";

export function useDuplicateNormasTeachingProduct() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const duplicateNormasTeachingProduct = async (
    productId: string,
  ): Promise<NormasTeachingProductDTO> => {
    try {
      setLoading(true);
      const { data } =
        await createAxiosInstance().post<NormasTeachingProductDTO>(
          `/products/${productId}/duplicate`,
        );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return {
    duplicateNormasTeachingProduct,
    loading,
  };
}
